import React, { useState } from "react";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  Polygon,
  useMap,
  Popup,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { useRef } from "react";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import { useEffect } from "react";
import jwt_decode from "jwt-decode";
import axios from "axios";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Input,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  ListItemText,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { refresh } from "../../refresh";
import { useNavigate } from "react-router-dom";
import { login, logout } from "../../reducers/userSlice";
import { useNavigatingAway } from "../../hooks/useNavigatingAway";
import { DialogLeavingPage } from "../../components/DialogLeavingPage";
import secureLocalStorage from "react-secure-storage";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";

const useStyles = makeStyles({
  table: {
    height: "auto",
  },
});

function getDistance(origin, destination) {
  // return distance in meters
  var lon1 = toRadian(origin[1]),
    lat1 = toRadian(origin[0]),
    lon2 = toRadian(destination[1]),
    lat2 = toRadian(destination[0]);

  var deltaLat = lat2 - lat1;
  var deltaLon = lon2 - lon1;

  var a =
    Math.pow(Math.sin(deltaLat / 2), 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(deltaLon / 2), 2);
  var c = 2 * Math.asin(Math.sqrt(a));
  var EARTH_RADIUS = 6371;
  return c * EARTH_RADIUS * 1000;
}

function toRadian(degree) {
  return (degree * Math.PI) / 180;
}

const PolygonMap = () => {
  const [position, setPosition] = useState([33.33, 35.33]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  // const [center, setCenter] = useState({ lat: 24.4539, lng: 54.3773 });
  const [mapLayers, setMapLayers] = useState([]);
  const [polygons, setPolygons] = useState([]);
  const [id, setId] = useState("");
  const [idDeleted, setIdDeleted] = useState("");
  const [name, setName] = useState("");
  const [selectedIndex, setSelectedIndex] = useState("");
  const [ZOOM_LEVEL, setZoom] = useState(11);
  const user = useSelector((state) => state.userSlice.user);
  const mapRef = useRef();
  const { REACT_APP_API_ENDPOINT } = process.env;

  const { setValue, dark } = useContext(UserContext);

  const [customerId, setCustomerId] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (!user) return;
    const roles = jwt_decode(user.token).roles;
    if (roles.includes("ROLE_ADMIN")) {
      if (customerId === "") return;
      console.log(
        `${REACT_APP_API_ENDPOINT}/api/getGeofenceByCustomer?customer=${customerId}`
      );
      setValue(true);
      axios
        .get(
          `${REACT_APP_API_ENDPOINT}/api/getGeofenceByCustomer?customer=${customerId}`,
          {
            headers: {
              Authorization: "Bearer " + user.token,
            },
          }
        )
        .then((data) => {
          console.log(data.data);
          const fences = data.data;
          setId(fences.id);

          if (fences.fence?.length > 0) {
            var points = fences.fence;
            points.map((point) => {
              return (point["saved"] = true);
            });

            var distance = getDistance(
              [
                points[points.length - 1].latlngs[0]["lat"],
                points[points.length - 1].latlngs[0]["lng"],
              ],
              [
                points[points.length - 1].latlngs[
                  points[points.length - 1].latlngs.length - 1
                ]["lat"],
                points[points.length - 1].latlngs[
                  points[points.length - 1].latlngs.length - 1
                ]["lng"],
              ]
            );
            const z = Math.log(distance);
            setZoom(20 - z);
            setPosition(points[points.length - 1].latlngs[0]);
            console.log(points);
            setPolygons(points);
            setMapLayers(points);
          } else {
            setPolygons([]);
            setMapLayers([]);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            refresh(dispatch, navigate);
          }
        })
        .finally(() => {
          setValue(false);
        });
    } else {
      console.log(`${REACT_APP_API_ENDPOINT}/api/geofences`);
      axios
        .get(`${REACT_APP_API_ENDPOINT}/api/geofences`, {
          headers: {
            Authorization: "Bearer " + user.token,
          },
        })
        .then((data) => {
          if (data.data["hydra:member"].length > 0) {
            setId(
              data.data["hydra:member"][data.data["hydra:totalItems"] - 1].id
            );

            if (
              data.data["hydra:member"][data.data["hydra:totalItems"] - 1].fence
                .length > 0
            ) {
              var points =
                data.data["hydra:member"][data.data["hydra:totalItems"] - 1]
                  .fence;
              points.map((point) => {
                return (point["saved"] = true);
              });

              var distance = getDistance(
                [
                  points[points.length - 1].latlngs[0]["lat"],
                  points[points.length - 1].latlngs[0]["lng"],
                ],
                [
                  points[points.length - 1].latlngs[
                    points[points.length - 1].latlngs.length - 1
                  ]["lat"],
                  points[points.length - 1].latlngs[
                    points[points.length - 1].latlngs.length - 1
                  ]["lng"],
                ]
              );
              const z = Math.log(distance);
              setZoom(20 - z);
              setPosition(points[points.length - 1].latlngs[0]);
              console.log(points);
              setPolygons(points);
              setMapLayers(points);
            }
          } else {
            setPolygons([]);
            setMapLayers([]);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            refresh(dispatch, navigate);
          }
        });
    }
  }, [REACT_APP_API_ENDPOINT, customerId, dispatch, navigate, setValue, user]);

  useEffect(() => {
    if (user === null) return;
    const roles = jwt_decode(user.token).roles;
    if (roles.includes("ROLE_ADMIN")) {
      setValue(true);
      axios
        .get(`${REACT_APP_API_ENDPOINT}/api/AllCustomers`, {
          headers: {
            Authorization: "Bearer " + user.token,
          },
        })
        .then((data) => {
          if (data.data["hydra:member"].length > 0) {
            setCustomerId(data.data["hydra:member"][0].id);
          }
          setCustomerList(data.data["hydra:member"]);
          setAllowed(true);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            refresh(dispatch, navigate);
          }
        })
        .finally(() => {
          setValue(false);
        });
    }
  }, [REACT_APP_API_ENDPOINT, dispatch, navigate, setValue, user]);

  const _onCreate = (e) => {
    console.log(e);
    setCanShowDialogLeavingPage(true);
    const { layerType, layer } = e;
    if (layerType === "polygon") {
      const { _leaflet_id } = layer;
      setPosition([
        layer.getLatLngs()[0][0]["lat"],
        layer.getLatLngs()[0][0]["lng"],
      ]);
      var distance = getDistance(
        [layer.getLatLngs()[0][0]["lat"], layer.getLatLngs()[0][0]["lng"]],
        [
          layer.getLatLngs()[0][layer.getLatLngs()[0].length - 1]["lat"],
          layer.getLatLngs()[0][layer.getLatLngs()[0].length - 1]["lng"],
        ]
      );
      const z = Math.log(distance);
      setZoom(20 - z);
      setMapLayers((layers) => [
        ...layers,
        { id: _leaflet_id, latlngs: layer.getLatLngs()[0] },
      ]);
    }
  };

  const _onEdited = (e) => {
    setCanShowDialogLeavingPage(true);
    console.log(e);
    const {
      layers: { _layers },
    } = e;

    Object.values(_layers).map(({ _leaflet_id, editing }) => {
      setMapLayers((layers) =>
        layers.map((l) =>
          l.id === _leaflet_id
            ? { ...l, latlngs: editing.latlngs[0].flat() }
            : l
        )
      );
    });
  };

  const named = (id, name) => {
    setCanShowDialogLeavingPage(true);
    setMapLayers((layers) =>
      layers.map((l) => (l.id === id ? { ...l, name: name } : l))
    );
  };

  const deleted = (id) => {
    setCanShowDialogLeavingPage(true);
    setMapLayers((layers) => layers.filter((l) => l.id !== id));
    setPolygons((layers) => layers.filter((l) => l.id !== id));
  };

  const _onDeleted = (e) => {
    setCanShowDialogLeavingPage(true);
    console.log(e);
    const {
      layers: { _layers },
    } = e;

    Object.values(_layers).map(({ _leaflet_id }) => {
      setMapLayers((layers) => layers.filter((l) => l.id !== _leaflet_id));
    });
  };
  const blackOptions = { color: "black" };

  const handleClose = () => {
    setOpen(false);
  };

  function ChangeView({ center, zoom }) {
    const map = useMap();
    map.flyTo(center, zoom, { duration: 2 });
    return null;
  }
  const handler = () => {
    setCanShowDialogLeavingPage(false);
    if (id !== "" && id !== undefined) {
      axios
        .put(
          `${REACT_APP_API_ENDPOINT}/api/geofences/` + id,

          {
            fence: mapLayers,
          },
          {
            headers: {
              Authorization: "Bearer " + user.token,
            },
          }
        )
        .then(() => {
          window.location.reload(false);
        })
        .catch((e) => {
          console.log(e);
          if (e.response.status === 401) {
            const refresh_token = localStorage.getItem("refresh_token");
            if (refresh_token) {
              axios
                .post(`${REACT_APP_API_ENDPOINT}/token/refresh`, {
                  refresh_token: refresh_token,
                })
                .then((data) => {
                  console.log("refresh");
                  axios
                    .put(
                      `${REACT_APP_API_ENDPOINT}/api/geofences/` + id,

                      {
                        fence: mapLayers,
                      },
                      {
                        headers: {
                          Authorization: "Bearer " + data.data.token,
                        },
                      }
                    )
                    .then(() => {
                      dispatch(
                        login({
                          loggedIn: true,
                          token: data.data.token,
                        })
                      );
                      window.location.reload(false);
                    });
                })
                .catch((e) => {
                  console.log(e);
                  dispatch(logout());
                  navigate("/login");
                });
            } else {
              console.log("no refresh token");
              dispatch(logout());
              navigate("/login");
            }
          }
        });
    } else {
      let url = "";

      if (allowed) {
        url = `${REACT_APP_API_ENDPOINT}/api/updateAdminGeofence?customer=${customerId}`;
      } else {
        url = `${REACT_APP_API_ENDPOINT}/api/geofences?customer=${customerId}`;
      }
      axios
        .post(
          url,
          {
            fence: mapLayers,
          },
          {
            headers: {
              Authorization: "Bearer " + user.token,
            },
          }
        )
        .then(() => {
          window.location.reload(false);
        })
        .catch((e) => {
          console.log(e);
          if (e.response.status === 401) {
            const refresh_token = localStorage.getItem("refresh_token");
            if (refresh_token) {
              axios
                .post(`${REACT_APP_API_ENDPOINT}/token/refresh`, {
                  refresh_token: refresh_token,
                })
                .then((data) => {
                  console.log("refresh");
                  axios
                    .post(
                      `${REACT_APP_API_ENDPOINT}/api/geofences`,

                      {
                        fence: mapLayers,
                      },
                      {
                        headers: {
                          Authorization: "Bearer " + data.data.token,
                        },
                      }
                    )
                    .then(() => {
                      dispatch(
                        login({
                          loggedIn: true,
                          token: data.data.token,
                        })
                      );
                      window.location.reload(false);
                    });
                })
                .catch((e) => {
                  console.log(e);
                  dispatch(logout());
                  navigate("/login");
                });
            } else {
              console.log("no refresh token");
              dispatch(logout());
              navigate("/login");
            }
          }
        });
    }
  };

  const classes = useStyles();

  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleChangeCustomer = (event) => {
    const value = event.target.value;
    setCustomerId(value);
  };

  const MenuProps = {
    PaperProps: {
      style: {
        height: "auto",
        width: 250,
      },
    },
  };
  return (
    <>
      <Box component="form">
        <DialogLeavingPage
          showDialog={showDialogLeavingPage}
          setShowDialog={setCanShowDialogLeavingPage}
          confirmNavigation={confirmNavigation}
          cancelNavigation={cancelNavigation}
        />
      </Box>
      <div style={{ display: "flex", flexDirection: "row" }}>
        {allowed && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
            }}
          >
            <div>
              <InputLabel
                id="demo-multiple-checkbox-label"
                style={{ color: dark ? "white" : "" }}
              >
                Customer
              </InputLabel>
              <Select
                style={{ width: "100px", height: "40px" }}
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                value={customerId}
                onChange={handleChangeCustomer}
                input={<OutlinedInput label="Customer" />}
                MenuProps={MenuProps}
                sx={{
                  color: dark ? "white" : "",
                  background: dark
                    ? "linear-gradient(90deg, #314f8b 0%, #281a4b 95%, #281a4b 100%)"
                    : "",
                  "& .MuiOutlinedInput-root": {
                    "& > fieldset": { borderColor: dark ? "white" : "" },
                  },
                }}
              >
                {customerList.map((data, index) => (
                  <MenuItem key={index} value={data.id}>
                    <ListItemText primary={data.name} />
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
        )}
        &nbsp; &nbsp;
        <MapContainer center={position} zoom={ZOOM_LEVEL} ref={mapRef}>
          <ChangeView center={position} zoom={ZOOM_LEVEL} />

          <FeatureGroup>
            <EditControl
              position="topright"
              onCreated={_onCreate}
              onEdited={_onEdited}
              onDeleted={_onDeleted}
              draw={{
                rectangle: false,
                polyline: false,
                circle: false,
                circlemarker: false,
                marker: false,
              }}
            />
          </FeatureGroup>

          <TileLayer
            url="https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png"
            attribution='&copy; OpenStreetMap France | &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          {polygons.map((element, index) => {
            return (
              <FeatureGroup color="purple" key={index}>
                <Popup position={element.latlngs}>
                  <p>{element.name}</p>
                </Popup>
                <Polygon
                  pathOptions={blackOptions}
                  positions={element.latlngs}
                />
              </FeatureGroup>
            );
          })}
        </MapContainer>
        <div style={{ marginLeft: "100px" }}>
          <TableContainer component={Paper} style={{ height: "85vh" }}>
            <Table
              sx={{ minWidth: 200 }}
              className={classes.table}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>
                    <div style={{ padding: 10 }}>Geofences</div>
                  </TableCell>
                  <TableCell>
                    <div style={{ padding: 10 }}>Name</div>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <div style={{ padding: 10 }}>
                      <button
                        style={{
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          paddingInline: "20px",
                          zIndex: "400",
                          borderRadius: 10,
                          background:
                            "linear-gradient(90deg, #281a4b 0%, #281a4b 15%, #314f8b 100%)",
                          color: "white",
                        }}
                        onClick={handler}
                      >
                        save
                      </button>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {mapLayers.map((row, index) => (
                  <>
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        onClick={() => {
                          var distance = getDistance(
                            [row.latlngs[0]["lat"], row.latlngs[0]["lng"]],
                            [
                              row.latlngs[row.latlngs.length - 1]["lat"],
                              row.latlngs[row.latlngs.length - 1]["lng"],
                            ]
                          );
                          const z = Math.log(distance);
                          setZoom(20 - z);
                          setPosition(row.latlngs[0]);
                        }}
                      >
                        <div style={{ padding: 10 }}>Geofence</div>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <div style={{ padding: 10 }}>{row.name}</div>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {selectedIndex !== index && (
                          <div style={{ padding: 10 }}>
                            <button
                              onClick={() => {
                                setSelectedIndex(index);
                                setName("");
                              }}
                              className="btn btn-info"
                              style={{ fontSize: 13 }}
                            >
                              {row.name !== "" && <span>Edit name</span>}
                              {row.name === "" && <span>Add name</span>}
                            </button>
                          </div>
                        )}
                        {selectedIndex === index && (
                          <>
                            <Input
                              type="text"
                              placeholder="name"
                              style={{ width: 100 }}
                              onChange={(e) => {
                                setName(e.target.value);
                              }}
                            />
                            &nbsp;
                            <button
                              onClick={() => {
                                named(row.id, name);
                                setSelectedIndex("");
                              }}
                              className="btn btn-success"
                              disabled={name === ""}
                              style={{ fontSize: 13 }}
                            >
                              save
                            </button>
                            &nbsp;
                            <button
                              onClick={() => {
                                setSelectedIndex("");
                                setName("");
                              }}
                              className="btn btn-warning"
                              style={{ fontSize: 13 }}
                            >
                              cancel
                            </button>
                          </>
                        )}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        onClick={() => {
                          setPosition(row.latlngs[0]);
                        }}
                      >
                        {row.saved && (
                          <div style={{ padding: 10 }}>
                            <button
                              onClick={() => {
                                setIdDeleted(row.id);
                                setOpen(true);
                              }}
                              className="btn btn-danger"
                              style={{ fontSize: 13 }}
                            >
                              Delete
                            </button>
                          </div>
                        )}
                      </TableCell>
                    </TableRow>
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Dialog
            open={open}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>{"Warning"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Are you sure you want to delete this fence ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Disagree</Button>
              <Button
                onClick={() => {
                  deleted(idDeleted);
                  setOpen(false);
                }}
              >
                Agree
              </Button>
            </DialogActions>
          </Dialog>
          {/* <pre className="text-left" style={{ color: "white" }}>
            {JSON.stringify(mapLayers, 0, 2)}
          </pre> */}
        </div>
      </div>
    </>
  );
};

export default PolygonMap;
